var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout",on:{"click":_vm.logout}},[_c('feather-icon',{staticClass:"mr-25",attrs:{"icon":"LogOutIcon"}}),_c('span',[_vm._v("Logout")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }